export default __webpack_public_path__ + "4f6cf1574352a86435686f634f1f7e6e.svg";